var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVinylPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 45,
    stroke: "#6E6E6E",
    strokeOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 45.5,
    r: 16,
    stroke: "#6E6E6E",
    strokeOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(1 0 0 -1 44 47)",
    fill: "#D9D9D9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    transform: "matrix(1 0 0 -1 44 47)",
    stroke: "#6E6E6E",
    strokeOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylPlaceholder);
export default __webpack_public_path__ + "static/media/vinyl-placeholder.a3120c5837a7a71f0de471a319eb9606.svg";
export { ForwardRef as ReactComponent };